import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { convertStringToArray } from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import LightBox from "../../../components/LightBox/LightBox";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import Viewer from "react-viewer";
import { imageUrl } from "../../../constants/constants";

function OtherCelebrationsById() {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { id } = useParams();
  const { data: otherEventsData, isLoading: otherEventsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "other_celebration",
      lang: languageType,
    });
  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };

  const eventObj = otherEventsData?.find((photo) => photo.nid === id);

  const photoArray = convertStringToArray(eventObj?.field_events_image);

  const photoGallery = photoArray?.map((url) => {
    return {
      title: url.title,
      src: `http://164.52.201.69${url.file_path}`,
    };
  });

  if (otherEventsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Azadi Ka Amrit Mahotsav", "आज़ादी का अमृत महोत्सव")}
        titleLink="/competition-celebrations"
        titleThree={eventObj.title}
        titleTwo={getText("Other Ceremonies", "अन्य समारोह")}
        levelTwo={true}
        levelThree={true}
        isActive={eventObj.title}
        titleLink2="/competition-celebrations"
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                {photoArray?.length === 0 ? (
                  <p>No photos available</p>
                ) : (
                  photoArray?.map((url, index) => (
                    <div
                      key={index}
                      className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3"
                    >
                      <div className="card-sec">
                        <div className="img-sec">
                          <a
                            className="masonry-item"
                            onClick={() => openViewer(photoArray, index)}
                          >
                            <img
                              src={imageUrl + url?.file_path}
                              alt={url.title}
                              width={100}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </section>
        </div>
      </div>

      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
}

export default OtherCelebrationsById;
